import { render, staticRenderFns } from "./UserDetailsLogs.vue?vue&type=template&id=bb7f943e&"
import script from "./UserDetailsLogs.vue?vue&type=script&lang=js&"
export * from "./UserDetailsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports